import { customAutoCompleteFilter, customBooleanFilter, standardGridPageSize } from "../../../Shared/GlobalVariables/filterVariables";
import { halSchemaKendoGrid } from "../../../Shared/kendo.module";

export default /*@ngInject*/ function (helperService, $http, dataService, reportsDataService) {

    const vm = this;
    vm.$onInit = activate;
    vm.$onChanges = onChanges;
    vm.selectUser = selectUser;
    vm.helperService = helperService;
    vm.availableProducts = [];


    async function activate() {
        // making metadata call so report is up to date
        await reportsDataService.getReportMetadata(reportId);
        await setupExpansionGrid();
    }

    async function onChanges(changes) {
        // Refresh the grid when selected applications change
        if (changes.selectedApplications && !changes.selectedApplications.isFirstChange()) {
            await setupExpansionGrid();
            // Refresh the grid data
            if (vm.ExistingUsersGridDataSource) {
                vm.ExistingUsersGridDataSource.read();
            }
        }
    }

    
    const reportId = 'e5f3c3b7-2b49-4192-bddb-17ff914682d6';

    async function setupExpansionGrid() {
        vm.expansionGridColumns = [
            { field: "FastpathUserName", title: "Fastpath User Name", template: `<user-profile user-display="dataItem.FastpathUserName" user-master-id="dataItem._hidden_UserMasterID"></user-profile>`, filterable: customAutoCompleteFilter, width: 125 },
            { field: "FastpathEmail", title: "Fastpath Email", filterable: customAutoCompleteFilter, width: 100 },
            { field: "UserCrossPlatformMapping", title: "Cross Platform User", filterable: customBooleanFilter, width: 100 }
        ];

        // Use the selected applications passed in as a binding instead of fetching separately
        // This ensures we're using the same product list as the parent
        vm.availableProducts = vm.selectedApplications || [];

        // Filter out products that are currently selected
        const selectedProductIds = vm.selectedApplications
            ? vm.selectedApplications.filter(app => app.selected).map(app => app.ProductId)
            : [];

        vm.availableProducts.forEach(product => {
            // Only add columns for products that are NOT selected
            if (!selectedProductIds.includes(product.Id)) {
                const productName = helperService.removeSpaces(product.Name)
                vm.expansionGridColumns = vm.expansionGridColumns.concat([
                    { field: productName, title: product.Name, width: 75, },
                    { field: productName + "UserId", title: product.Name + " ID", width: 100, },
                    { field: productName + "UserName", title: product.Name + " User Name", width: 130, },
                    { field: productName + "Email", title: product.Name + " Email", width: 125, }
                ]);
            }
        });


        // Table data setup
        const fields = { UserCrossPlatformMapping: { type: "boolean" } };
        vm.availableProducts.forEach(product => {
            // Only add fields for products that are NOT selected
            if (!selectedProductIds.includes(product.Id)) {
                fields[helperService.removeSpaces(product.Name)] = { type: "boolean" }
            }
        });
       

        vm.ExistingUsersGridOptions = helperService.setMainGridOptions(vm.expansionGridColumns, 350);
        vm.ExistingUsersGridOptions.selectable = true;
        vm.ExistingUsersGridOptions.persistSelection = true;
        vm.ExistingUsersGridDataSource = new kendo.data.DataSource({
            pageSize: standardGridPageSize,
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            schema: angular.extend(halSchemaKendoGrid, {
                model: {
                    id: '_hidden_UserMasterID',
                    fields: fields
                }
            }),
            transport: {
                read: async options => {
                    const params = {
                        "pagesize": options.data.pageSize,
                        "page": options.data.page
                    }, sortsAndFilters = helperService.prepareSortsAndFilters(options);

                    try {
                        let response = await $http.post(`${apiUrl}api/core/reports/${reportId}/execute`, sortsAndFilters, { params: params });
                        let data = response.data;

                        // HAL format: data is in _embedded.reportData
                        const reportData = data._embedded && data._embedded.reportData ? data._embedded.reportData : [];

                        // Filter users based on selected applications
                        if (reportData.length > 0 && vm.selectedApplications && vm.selectedApplications.length > 0) {
                            // Get product names (without spaces) for selected and non-selected products
                            const selectedProductNames = vm.selectedApplications
                                .filter(app => app.selected)
                                .map(app => helperService.removeSpaces(app.Name));

                            const nonSelectedProductNames = vm.selectedApplications
                                .filter(app => !app.selected)
                                .map(app => helperService.removeSpaces(app.Name));

                            // Only filter if there are selected products
                            if (selectedProductNames.length > 0) {
                                const filteredUsers = reportData.filter(user => {
                                    // Check if user has any account in selected products
                                    const hasSelectedProductAccount = selectedProductNames.some(productName => {
                                        return user[productName] === true;
                                    });

                                    // Check if user has at least one account in non-selected products
                                    const hasNonSelectedProductAccount = nonSelectedProductNames.length > 0
                                        ? nonSelectedProductNames.some(productName => {
                                            return user[productName] === true;
                                        })
                                        : false;

                                    // Only include users who:
                                    // 1. DON'T have accounts in selected products
                                    // 2. DO have accounts in at least one non-selected product
                                    return !hasSelectedProductAccount && hasNonSelectedProductAccount;
                                });

                                // Update the HAL response structure with filtered data
                                data._embedded.reportData = filteredUsers;
                                data.TotalItems = filteredUsers.length;
                            }
                        }

                        options.success(data);
                    } catch (error) {
                        options.error();
                        helperService.showErrorMessage(error.data);
                    }
                }
            }
        });
    }

    function selectUser(kendoEvent) {
        let grid = kendoEvent.sender;
        let linkedUser = grid.dataItem(grid.select());
        vm.linkedUserChange({ linkedUser });
    }
}